export const productUrl = "https://lrd.lornax.cloud/";

export const sections = [
  { id: "opening", label: "开场", title: "今天不是产品广告，是一次 AI 共创拆解" },
  { id: "why", label: "为什么做", title: "一个人备考真正缺的不是资料" },
  { id: "method", label: "方法", title: "vibe coding 不是让 AI 瞎写" },
  { id: "timeline", label: "历程", title: "从想法到备案上线" },
  { id: "pitfalls", label: "真实坑", title: "四个踩坑长出来的技巧" },
  { id: "product", label: "产品演示", title: "打开刷题宝看看" },
  { id: "cta", label: "行动入口", title: "试用产品，继续关注创作过程" }
] as const;

export const openingChoices = {
  sectionId: "opening",
  questionId: "primary-interest",
  title: "你今天最关心什么？",
  choices: [
    { id: "build-ai-product", label: "想做自己的 AI 产品" },
    { id: "learn-vibe-coding", label: "想学习 vibe coding 方法" },
    { id: "try-product", label: "想试试刷题宝" },
    { id: "follow-creator", label: "想关注在瓶的 AI 创作过程" }
  ]
};

export const methodChoices = {
  sectionId: "method",
  questionId: "current-blocker",
  title: "如果你现在要做一个 AI 产品，最容易卡在哪？",
  choices: [
    { id: "problem", label: "问题说不清" },
    { id: "prototype", label: "原型看不见" },
    { id: "implementation", label: "代码拆不动" },
    { id: "deployment", label: "部署不稳定" },
    { id: "verification", label: "不知道怎么验收" }
  ]
};

export const productInterestChoices = {
  sectionId: "product",
  questionId: "product-interest",
  title: "你会怎么使用刷题宝？",
  choices: [
    { id: "use-myself", label: "自己试用" },
    { id: "recommend-to-friends", label: "推荐给身边备考的人" },
    { id: "study-the-method", label: "主要学习产品方法" },
    { id: "not-now", label: "暂时只是了解" }
  ]
};

export const timelineItems = [
  ["起点", "从自己的 NPDP 备考痛点出发：资料散、错题断、AI 没上下文。"],
  ["不 fork", "从空项目起步，不复制旧项目复杂度，不带无用渠道。"],
  ["先原型", "写代码前先用 HTML 看路径，让产品决策发生在工程投入前。"],
  ["MVP", "跑通建档、手输加题、刷题、错题本这条最小闭环。"],
  ["AI 加题", "接入拍照识题、PDF 导入、AI 出题和查重。"],
  ["真实修坑", "PDF 异步导入、worker 断点续传、登录 race、Prompt 状态注入。"],
  ["上线分享", "产品完成备案，路演页导向 https://lrd.lornax.cloud/。"]
] as const;

export const techniqueCards = [
  {
    id: "no-complexity-copy",
    title: "不抄复杂度",
    lesson: "新项目第一件事不是找模板，而是决定什么不要带进来。",
    example: "刷题宝不 fork 旧项目，不带微信渠道，不开高风险 React Compiler。",
    reuse: "每加一个依赖、渠道、模块，都问：现在真的需要它吗？"
  },
  {
    id: "prototype-first",
    title: "原型先行",
    lesson: "先看见页面和路径，再让 AI 写工程代码。",
    example: "旧版学不死先做高保真 HTML 原型，再进入 Vite/React 实现。",
    reuse: "让 AI 先产出可点击原型，用真实内容走一遍，再拆实现。"
  },
  {
    id: "recoverable-worker",
    title: "异步任务要可恢复",
    lesson: "进程内状态是定时炸弹，长任务状态必须能从数据库恢复。",
    example: "100 题 PDF 导入改成 chunk、进度、候选题持久化，服务重启可续跑。",
    reuse: "任何超过 10 秒的 AI 任务，都要保存输入、进度、中间结果和失败原因。"
  },
  {
    id: "stateful-prompt",
    title: "Prompt 注入真实状态",
    lesson: "AI 不该凭感觉鼓励用户，而要基于真实数据给下一步。",
    example: "AI 陪学读取题库数、错题数、距考时间、上次刷题时间，再给建议。",
    reuse: "把产品状态整理成 system prompt，给 AI 明确字数、口吻和决策规则。"
  }
] as const;

export const productPath = [
  {
    id: "profile",
    label: "建档",
    title: "建立备考档案",
    text: "先把考试、目标日期、每日投入和最近题目放进一个档案，AI 才知道你是谁、要去哪。",
    screenshot: "/assets/product/01-profile-list.png"
  },
  {
    id: "textbook",
    label: "输入教材",
    title: "教材库导入资料",
    text: "上传教材 PDF，解析章节和知识段，让后续答题、解析、AI 陪学都有资料依据。",
    screenshot: "/assets/product/02-textbook-library.png"
  },
  {
    id: "question-input",
    label: "输入试题",
    title: "多入口加入试题",
    text: "手输、拍照、PDF 导入、AI 生成都能进入题库，先把资料变成可练习的题。",
    screenshot: "/assets/product/03-add-question.png"
  },
  {
    id: "quiz",
    label: "刷题题库",
    title: "开始刷题",
    text: "在题库里刷题、提交、看解析和进度，产品的主路径不再停留在资料收藏。",
    screenshot: "/assets/product/04-quiz-session.png"
  },
  {
    id: "wrongbook",
    label: "错题库",
    title: "沉淀错题",
    text: "答错自动沉淀，掌握后再移除，让复盘不靠记忆力，而靠产品闭环。",
    screenshot: "/assets/product/05-wrongbook.png"
  },
  {
    id: "coach",
    label: "陪学聊天",
    title: "AI 陪学",
    text: "AI 读取题库数、错题数、教材和距考时间，给出下一步建议，而不是泛泛聊天。",
    screenshot: "/assets/product/06-study-chat.png"
  }
] as const;
